import * as React from 'react';
import { Properties, Values } from '../';
import { DropdownTabbed, ContentEditableTinyMCE } from '../';
import { IAction, IProperty, EPropertyTypes, DOMHelper, IFieldConfig, IFilterPropertyDictionary, PropertyHelper, IDropdownOptionDictionary, IFieldError, IOutput, ModalHelper } from '../../helpers';
import {
    DialogFooter,
    Button, ButtonType,
    Pivot, PivotItem, PivotLinkSize,
    IDropdownOption,
    Spinner,
    SpinnerType
} from 'office-ui-fabric-react';
import store from '../../store/store';
import types from '../../store/types';

interface IProps {
    action: IAction;
    fieldConfigs: IFieldConfig[];
    entityOutputs?: IOutput[];
    fetchXMLOutputs?: IOutput[];
    entityOptionSet?: IDropdownOption[];
    entityStateCode?: IDropdownOption[];
    statusReason?: IDropdownOption[];
    fieldError?: IFieldError;
    fieldTypes: IDropdownOption[];
    dropdownOptions: IDropdownOption[];
    actionTypes: IDropdownOption[];
    entityFields?: IDropdownOption[];
    entityViews?: IDropdownOption[];
    globalOutputDropdownOptions: IDropdownOption[];
    outputTypeDropdownOptions: IDropdownOption[];
    outputValueDropdownOptions?: IDropdownOption[];
    loadingTemplate?: string;
    propertyFilters: IFilterPropertyDictionary;
    closeDialog: (save?: boolean) => void;
    actionTypeChange: (item: IDropdownOption) => void;
    onLoad: (action: IAction) => void;
    updateProperty: (key: string, value: any) => void;
    updateEntityProperty?: (key: string, value: any) => void;
    updateGetRecordEntityProperty?: (key: string, value: any) => void;
    changeEntityView?: (key: string, value: any) => void;
    // updateProperty: (key: string, value: any) => Promise<any>;
    updateOutput: (index: number, name: string) => void;
    outputBlur: (index: number, name: string, staticName: string, logicalName: string) => void;
    updateSelectedGlobalOutput: (index: number, key: string) => void;
    updateSelectedOutputType: (index: number, type: number) => void;
    updateOutputStaticName: (index: number, staticName: string) => void;
    updateOutputLogicalName: (index: number, logicalName: string) => void;
    updateOutputDefaultValue: (index: number, defaultValue: string) => void;
    updateGetRecordOutputDefaultValue?: (logincalName: string, defaultValue: string) => void;
    addActionOutput: () => void;
    addActionOutputArray?: (output: IOutput) => void;
    removeActionOutputArray?: (output: IOutput) => void;
    deleteActionOutput: (index: number) => void;
    addField: () => void;
    addFieldFromMetadata: (fieldName: string, fieldValue: string, fieldType: number, fieldRequired?: boolean, friendlyName?: string, entityReference?: string) => void;
    updateFieldName: (index: number, name: string) => void;
    updateFieldValue: (index: number, value: string) => void;
    updateValueOptionsFieldValue: (index: number, value: string) => void;
    updateFieldType: (index: number, key: number) => void;
    updateFieldRequired: (index: number, key: boolean) => void;
    deleteField: (index: number) => void;
    setAdvancedSettingsIndex: (index: number) => void;
    setModalWarningMessages: (warningMessages: string[]) => void;
    advancedSettingsIndex: number;
    entityChange?: (item: IDropdownOption) => void;
    fieldElements?: JSX.Element[];
}

const actionPivotKey: string = 'pivot_action';

export class ActionConfig extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            selectedPivotItemKey: actionPivotKey
        }
    }

    public componentDidMount() {
        let { action, onLoad, entityFields, addFieldFromMetadata } = this.props;
        onLoad(action);
        DOMHelper.setDropdownPropertyTabIndex();
        DOMHelper.focusOnFirstModalTabbableControl();

        // entityFields.map((val, index) => {
        //     addFieldFromMetadata(val.text, val.key.toString(), 0);
        // });

    }

    // public componentDidUpdate(prevProps) {

    //     DOMHelper.setDropdownPropertyTabIndex();
    //     if(!(prevProps.action.ActionType) ||
    //         (prevProps.action.ActionType.NameType !== this.props.action.ActionType.NameType) ||
    //         (prevProps.action.Properties.length !== this.props.action.Properties.length)    
    //     ) {
    //         DOMHelper.focusOnFirstModalTabbableControl();
    //     }
    // }

    private onPivotLinkClick = (item: PivotItem, event: React.MouseEvent<HTMLElement>) => {
        let { TabEnabledConditions, Properties } = this.props.action;

        let tabEnabledConditionsMetMessages: string[] =
            PropertyHelper.TabEnabledConditionsMet(item.props.linkText, this.props.action.TabEnabledConditions, this.props.action.Properties);

        if (tabEnabledConditionsMetMessages.length) {
            this.props.setModalWarningMessages(tabEnabledConditionsMetMessages);
        }
        else {
            this.props.setModalWarningMessages([]);
            this.setState({
                selectedPivotItemKey: item.props.itemKey
            });
        }
    }

    close(bool: boolean) {
        let { closeDialog,
        } = this.props;

        if (bool && this.props.action.ActionType.NameType === "Create Record") {
            // check if the required fields have values
            const requiredFields = Object.keys(this.props.fieldConfigs).filter(x => this.props.fieldConfigs[x].FieldRequired);
            let isRequiredFieldEmpty = false;
            requiredFields.forEach(element => {
                if (!this.props.fieldConfigs[element].FieldValue) {
                    isRequiredFieldEmpty = true;
                }
                if (this.props.fieldConfigs[element].ValueOptionsFieldValue) {
                    isRequiredFieldEmpty = false;
                }
            });
            if (isRequiredFieldEmpty) {
                const errorMessages = ["A value must be supplied for required field."];
                store.dispatch({
                    type: types.SET_MODAL_ERROR_MESSAGES,
                    errorMessages: errorMessages
                });

                //scroll to the top of the dialog so that the error message is visible
                ModalHelper.scrollToErrorDisplay();

            }
            else {
                closeDialog(bool);
            }
        }
        else {
            closeDialog(bool);
        }
    }

    public render() {

        let {
            action, actionTypes, closeDialog, actionTypeChange, updateProperty, updateEntityProperty, updateGetRecordEntityProperty, changeEntityView, dropdownOptions, globalOutputDropdownOptions,
            outputTypeDropdownOptions, outputValueDropdownOptions, updateOutput, updateSelectedGlobalOutput, updateOutputStaticName,
            updateOutputLogicalName, addActionOutput, addActionOutputArray, removeActionOutputArray, deleteActionOutput, updateSelectedOutputType, outputBlur, setAdvancedSettingsIndex,
            updateOutputDefaultValue, updateGetRecordOutputDefaultValue, advancedSettingsIndex, propertyFilters, fieldElements,
            addField, addFieldFromMetadata, updateFieldName, updateFieldValue, updateValueOptionsFieldValue, updateFieldType, updateFieldRequired, deleteField,
            fieldError, fieldConfigs, entityOptionSet, entityStateCode, fieldTypes, loadingTemplate, entityChange, entityOutputs, fetchXMLOutputs, entityFields,
            statusReason, entityViews
        } = this.props;

        //remove Title property and set ValueOptions for all input properties
        let propertiesToRender: IProperty[] = action.Properties.filter((v) => {
            return v.Name !== 'Action Name';
        }).map((v) => {
            if (v.Type === EPropertyTypes.input) {
                v.ValueOptions = dropdownOptions;
            }
            return v;
        });

        let filteredValueOptions: IDropdownOptionDictionary = PropertyHelper.getFilteredValueOptions(propertiesToRender, propertyFilters);

        let outputs = action.OutputValues;
        let selectedActionType = loadingTemplate || (action.ActionType ? action.ActionType.NameType : null);
        let pivots: JSX.Element[] = [
            <PivotItem key={actionPivotKey} itemKey={actionPivotKey} linkText='Action'>
                <DropdownTabbed
                    tabIndex={1}
                    required={true}
                    label='Action Type:'
                    options={actionTypes}
                    onChanged={actionTypeChange}
                    selectedKey={selectedActionType === 'Search Records' ? 'Get Records' : selectedActionType}
                    className="type-selector"
                />

                {
                    loadingTemplate
                        ? <Spinner type={SpinnerType.large} label={`Loading ${selectedActionType}...`} />
                        : <Properties primaryOnly={false} change={updateProperty}
                            changeEntity={updateEntityProperty}
                            updateGetRecordEntityProperty={updateGetRecordEntityProperty}
                            changeEntityView={changeEntityView} componentId={action.ComponentId}
                            properties={propertiesToRender} outputOptions={dropdownOptions}
                            filteredValueOptions={filteredValueOptions} entityOptionSet={entityOptionSet}
                            entityStateCode={entityStateCode} statusReason={statusReason} entityViews={entityViews} />
                }
                {(!loadingTemplate && (outputs || fieldConfigs)) ?
                    <Values
                        action={action}
                        outputs={outputs}
                        fields={fieldConfigs}
                        fieldError={fieldError}
                        advancedSettingsIndex={advancedSettingsIndex}
                        globalOutputDropdownOptions={globalOutputDropdownOptions}
                        outputDropdownOptions={dropdownOptions}
                        outputValueDropdownOptions={outputValueDropdownOptions}
                        HasUIDefinedOutputs={action.ActionType ? action.ActionType.HasUIDefinedOutputs : false}
                        outputHandler={{
                            updateOutput: updateOutput,
                            outputBlur: outputBlur,
                            updateSelectedGlobalOutput: updateSelectedGlobalOutput,
                            updateSelectedOutputType: updateSelectedOutputType,
                            updateOutputLogicalName: updateOutputLogicalName,
                            addActionOutput: addActionOutput,
                            addActionOutputArray: addActionOutputArray,
                            removeActionOutputArray: removeActionOutputArray,
                            deleteActionOutput: deleteActionOutput,
                            setAdvancedSettingsIndex: setAdvancedSettingsIndex,
                            updateOutputDefaultValue: updateOutputDefaultValue,
                            updateGetRecordOutputDefaultValue: updateGetRecordOutputDefaultValue,
                            updateOutputStaticName: updateOutputStaticName
                        }}
                        fieldHandler={{
                            addField: addField,
                            addFieldFromMetadata: addFieldFromMetadata,
                            updateFieldName: updateFieldName,
                            updateFieldValue: updateFieldValue,
                            updateValueOptionsFieldValue: updateValueOptionsFieldValue,
                            updateFieldType: updateFieldType,
                            updateFieldRequired: updateFieldRequired,
                            deleteField: deleteField
                        }}
                        fieldTypes={fieldTypes}
                        outputTypeDropdownOptions={outputTypeDropdownOptions}
                        outputOptions={dropdownOptions}
                        entityFields={entityFields}
                        entityOutputs={entityOutputs}
                        fetchXMLOutputs={fetchXMLOutputs}
                        fieldElements={fieldElements}
                    />
                    : null}
            </PivotItem>


        ];

        // Output panel
        // if (!loadingTemplate && (outputs || fieldConfigs))
        pivots.push(<PivotItem itemKey="pivot_values" key="pivot_values" linkText='Outputs'>
            {(!loadingTemplate && (outputs || fieldConfigs)) ?

                <Values
                    displayOnlyOutputs={true}
                    action={action}
                    outputs={outputs}
                    fields={fieldConfigs}
                    fieldError={fieldError}
                    advancedSettingsIndex={advancedSettingsIndex}
                    globalOutputDropdownOptions={globalOutputDropdownOptions}
                    outputDropdownOptions={dropdownOptions}
                    outputValueDropdownOptions={outputValueDropdownOptions}
                    HasUIDefinedOutputs={action.ActionType ? action.ActionType.HasUIDefinedOutputs : false}
                    outputHandler={{
                        updateOutput: updateOutput,
                        outputBlur: outputBlur,
                        updateSelectedGlobalOutput: updateSelectedGlobalOutput,
                        updateSelectedOutputType: updateSelectedOutputType,
                        updateOutputLogicalName: updateOutputLogicalName,
                        addActionOutput: addActionOutput,
                        addActionOutputArray: addActionOutputArray,
                        removeActionOutputArray: removeActionOutputArray,
                        deleteActionOutput: deleteActionOutput,
                        setAdvancedSettingsIndex: setAdvancedSettingsIndex,
                        updateOutputDefaultValue: updateOutputDefaultValue,
                        updateGetRecordOutputDefaultValue: updateGetRecordOutputDefaultValue,
                        updateOutputStaticName: updateOutputStaticName
                    }}
                    fieldHandler={{
                        addField: addField,
                        addFieldFromMetadata: addFieldFromMetadata,
                        updateFieldName: updateFieldName,
                        updateFieldValue: updateFieldValue,
                        updateValueOptionsFieldValue: updateValueOptionsFieldValue,
                        updateFieldType: updateFieldType,
                        updateFieldRequired: updateFieldRequired,
                        deleteField: deleteField
                    }}
                    fieldTypes={fieldTypes}
                    outputTypeDropdownOptions={outputTypeDropdownOptions}
                    outputOptions={dropdownOptions}
                    entityFields={entityFields}
                    entityOutputs={entityOutputs}
                    fetchXMLOutputs={fetchXMLOutputs}
                    fieldElements={fieldElements}
                />
                : null
            }

            {/* <h3>Outputs</h3>
            <table className="outputs-table">
                <thead>
                    {
                        this.headerHTML()
                    }
                </thead>
                <tbody>
                    {outputs}
                </tbody>
            </table> */}
        </PivotItem>);

        return (
            <div>

                <Pivot linkSize={PivotLinkSize.large} onLinkClick={this.onPivotLinkClick} selectedKey={this.state.selectedPivotItemKey}>
                    {pivots}
                </Pivot>

                <DialogFooter>
                    <Button tabIndex={1001}
                        buttonType={ButtonType.normal} onClick={() => this.close(false)}>Cancel</Button>
                    <Button tabIndex={1002} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}
                        buttonType={ButtonType.primary} onClick={() => this.close(true)} >Save</Button>
                </DialogFooter>

            </div>
        );

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/actions/action-config.tsx